import React, { Fragment } from 'react';

import { withStyles } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import { Button, Paper } from '@material-ui/core'; 
import AddBoxRounded from '@material-ui/icons/AddBoxRounded';
import DeleteIcon from '@material-ui/icons/DeleteOutlineOutlined';

import Cart from '../../models/Cart';
import CartItem from '../../models/CartItem';
import CartService from '../../models/CartService';
import AddServicesTariff from '../../models/AddServicesTariff';
import { UserRoleType } from '../../models/User';

import Moment from 'moment';

import cartStyles from './cart.module.css';
import commonStyles from '../common/common.module.css';

import { formatCurrency } from '../../utils/currencyFormatter';
import { getAdditionalServiceName, getAdditionalServiceDetails } from '../../utils/additionalServices';
import Tooltip from '@material-ui/core/Tooltip';

const iconFontSize = 20;
const PADDING_RIGHT = 0;
const styles = (theme: any) => ({

  materialIcon: {
    color: '#000',
    fontSize: iconFontSize,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  addBox: {
    cursor: 'pointer',
    color: 'var(--primaryblue)'
  },
  iconFs: {
    fontSize: '22px !important'
  },
  awbWrapper: {
    display: 'flex',
    justifyContent: 'space-between',  
  },
  number: {
    width: '45%'
  },
  pieces: {
    width: '15%'
  },
  weight: {
    width: '25%'
  },
});

interface CartProps {
  classes: any;
  cart: Cart;
  openAddServicesModal: any;
  openPaymentHistoryModal: Function;
  addServicesTariff: AddServicesTariff;
  deleteAwbFromCard: Function;
  userRole: UserRoleType;
};

const cart = (props: CartProps) => {

  const { classes, addServicesTariff } = props;

  return (
    <Fragment>
      <div className={ `${ commonStyles.wrapper } ${ cartStyles.wrapper }` }>
        <h3 className={ commonStyles.header }> AWB Details </h3>
        <MaterialTable

          components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}
          
          data = { props.cart.items }

          columns = {[
            { title: 'Airwaybill', field: '', cellStyle: { cursor: 'pointer', paddingTop: '10px', paddingRight: PADDING_RIGHT, whiteSpace: 'nowrap' },
              render: (rowData: CartItem) => { 

                return (
                  <Fragment>
                    <div className={ classes.awbWrapper }>
                      <span className={ classes.number }>{ rowData.code }-{ rowData.number } </span> 
                    </div>
                  </Fragment>
                );
              }  
            },
            { title: 'Arrival Date', field: 'arrival_date', cellStyle: { paddingTop: '10px', paddingRight: PADDING_RIGHT }, headerStyle: { paddingRight: PADDING_RIGHT },
              render: (rowData: CartItem) => {
                
                const arrivalDate: string = rowData.arrival_date ? Moment(rowData.arrival_date).format('DD-MMM-YY').toUpperCase() : '';
                return <span>{ arrivalDate }</span>;
              }
            },
            { title: 'Pcs', field: 'added_pieces', cellStyle: { paddingTop: '10px', textAlign: 'left', paddingRight: PADDING_RIGHT }, headerStyle: { paddingRight: PADDING_RIGHT } },
            { title: 'Wgt', field: '', cellStyle: { paddingTop: '10px', textAlign: 'left' , paddingRight: PADDING_RIGHT}, headerStyle: { paddingRight: PADDING_RIGHT },
              render: (rowData: CartItem) => {

                const weight: number = +(rowData.added_weight);
                return <span>{ weight.toFixed(1) }K</span>;
              },  
            },
            { title: 'Fee', field: '', cellStyle: { paddingTop: '10px', paddingRight: PADDING_RIGHT, whiteSpace: 'nowrap' }, 
              render: (rowData: CartItem) => {

                const fees: JSX.Element[] = rowData.services.map((service: CartService, index: number) => {
                  const storageText = service.type === 'storage_fee' && !rowData.storage && rowData.part ? `${getAdditionalServiceName(service.type)} (Not applied On Part)` : service.type === 'storage_fee' && rowData.part ? `${getAdditionalServiceName(service.type)} (Applied On Part)` : getAdditionalServiceName(service.type);
                  return (
                  <div key={ index } className={ cartStyles.feeName }>
                    { storageText }:
                    { service.type === 'other' || service.type === 'gha_adjust' ? ' ' + service.params.reason : ''}
                  </div>
                )});
              
                return <div>{ fees }</div>;
              }
            },
            { title: 'Details', field: '', cellStyle: { paddingTop: '10px' , paddingRight: PADDING_RIGHT, whiteSpace: 'nowrap'},
              render: (rowData: CartItem) => {

                const dues: JSX.Element[] = rowData.services.map((service: CartService, index: number) => (
                  <div key={ index } className={ cartStyles.dueRow }>
                    <div>{ getAdditionalServiceDetails(service, rowData.weight) }</div>
                  </div>
                ));

                return <div>{ dues }</div>;
              }
            },
            { title: 'Charges Due', field: '' , cellStyle: { paddingTop: '10px', paddingRight: PADDING_RIGHT }, headerStyle: { paddingRight: PADDING_RIGHT },
              render: (rowData: CartItem) => {

                const dues: JSX.Element[] = rowData.services.map((service: CartService, index: number) => (
                  <div key={ index } className={ cartStyles.dueRow }>
                    <div>$</div> 
                    <div>{ formatCurrency(service.remain, 2) }</div>
                  </div>
                ));

                return <div>
                    { dues }
                    <div className={ `${ cartStyles.dueRow } ${ cartStyles.dueSumRow }` }>
                      <div>$</div> 
                      <div>{ formatCurrency(rowData.remainDue, 2) }</div>
                    </div>
                  </div>;
              }
            },
            { title: 'Add Svc', field: '', cellStyle: { paddingTop: '10px', textAlign: 'center', paddingRight: PADDING_RIGHT }, headerStyle: {  paddingRight: PADDING_RIGHT, textAlign: 'center' },
              render: (rowData: CartItem) => {

                return <Tooltip title="Add additional services">
                  <AddBoxRounded className={`${ classes.iconFs } ${ classes.addBox }`} onClick={ () => props.openAddServicesModal(rowData) } />
                  </Tooltip>;
              }
            },
            { title: 'Action', headerStyle: { textAlign: 'center' , maxWidth: '63px'}, 
              render: (rowData: CartItem) => {

                return <span className={ cartStyles.functionPanelStyle }>
                  {rowData.part && <Tooltip title="Show payment history">
                    <Button color="primary" className={`${ classes.iconFs } ${ cartStyles.historyBtn }`} onClick={ (event) => props.openPaymentHistoryModal(rowData) } >H</Button>
                  </Tooltip>}
                  <Tooltip title="Remove from cart">
                    <DeleteIcon className={`${ classes.iconFs } ${ classes.materialIcon }`} onClick={ (events) => props.deleteAwbFromCard(rowData.code, rowData.number) } />
                  </Tooltip>

                </span>;
              }
            }
          ]}
            
          options = {{
            selection: false,
            paging: false,
            pageSize: 10,
            headerStyle: {
              backgroundColor: 'var(--tbl_head_bkg)',
              color: 'var(--tbl_head_color)',
              zIndex: 2,
            },
            showTitle: false,
            pageSizeOptions: [15,20],
            toolbar: false,
            sorting: false,
            rowStyle: {
              verticalAlign: 'top'
            }
          }}
        />
      </div>
      <div className={ cartStyles.totalWrapper }>
        <span className= { cartStyles.totalLabel }>Total:</span>
        <span>{ formatCurrency(props.cart.remainDue, 2, '$') }</span>
      </div>
    </Fragment>
  );
};

export default withStyles(styles)(cart);